import { getPeriodClosings } from '../services/api';
import { createEntityStore } from '@redpanda/utils';
import { toast } from 'react-hot-toast';

interface PeriodClosing {
  id: string;
  periodId: string;
  type: 'MONTHLY' | 'QUARTERLY' | 'YEARLY';
  status: 'PENDING' | 'PROCESSING' | 'COMPLETED' | 'FAILED' | 'REOPENED';
  startedAt: string;
  completedAt?: string;
  notes?: string;
  trialBalance: any;
  errors?: string[];
  createdAt: string;
  updatedAt: string;
  period: {
    id: string;
    name: string;
    startDate: string;
    endDate: string;
    status: 'OPEN' | 'CLOSED';
    fiscalYear: {
      id: string;
      name: string;
      organizationId: string;
    };
  };
}

const usePeriodClosingStoreBase = createEntityStore<PeriodClosing>({
  entityName: 'period-closings',
  fetchFn: (page: number) => getPeriodClosings(page, 20),
  // 期間結算不支援刪除
  deleteFn: async () => { throw new Error('期間結算記錄不能刪除'); },
  toast
});

export const usePeriodClosingStore = () => {
  const store = usePeriodClosingStoreBase();
  
  return {
    periodClosings: store.items,
    pagination: store.pagination,
    currentPage: store.currentPage,
    error: store.error,
    isLoading: store.isLoading,
    isPageLoading: store.isPageLoading,
    showDeleteConfirmModal: store.showDeleteConfirmModal,
    itemToDeleteId: store.itemToDeleteId,
    isDeleting: store.isDeleting,
    fetchPeriodClosings: store.fetchItems,
    setCurrentPage: store.setCurrentPage,
    handleDelete: store.handleDelete,
    confirmDelete: store.confirmDelete,
    closeDeleteModal: store.closeDeleteModal,
    lastOptimisticUpdate: store.lastOptimisticUpdate,
    refreshData: store.refreshData,
    updatePeriodClosing: store.updateItem,
    addPeriodClosing: store.addItem,
    getPeriodClosingById: store.getItemById,
  };
};

// 導出基礎 store 供其他模組使用
export { usePeriodClosingStoreBase };